import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { CompareProvider } from "./lib/compare";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import AuthCallback from "./pages/AuthCallback";
import MapDashboard from "./pages/MapDashboard";
import FARCalculator from "./pages/FARCalculator";
import AdvisoryBooking from "./pages/AdvisoryBooking";
import AdminDashboard from "./pages/AdminDashboard";
import Compare from "./pages/Compare";
import Projects from "./pages/Projects";
import PropertiesIndex from "./pages/PropertiesIndex";
import PropertiesCategory from "./pages/PropertiesCategory";
import EngagementPopup from "./components/EngagementPopup";

function Shell() {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}

function ProtectedAdmin() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-[70vh] grid place-items-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/map" replace />;
  return <AdminDashboard />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<Landing />} />
        <Route path="/map" element={<MapDashboard />} />
        <Route path="/dashboard" element={<MapDashboard />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/properties" element={<PropertiesIndex />} />
        <Route path="/properties/:location" element={<PropertiesCategory />} />
        <Route path="/properties/:location/:type" element={<PropertiesCategory />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/calculator" element={<FARCalculator />} />
        <Route path="/bookings" element={<AdvisoryBooking />} />
        <Route path="/admin" element={<ProtectedAdmin />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CompareProvider>
          <BrowserRouter>
            <AppRouter />
            <EngagementPopup />
            <Toaster theme="dark" position="top-right" richColors />
          </BrowserRouter>
        </CompareProvider>
      </AuthProvider>
    </div>
  );
}
